import { ElementRef, ChangeDetectorRef, } from '@angular/core';
import { UsersService } from '../../services/users.service';
import { UserWaterViewModel } from '../../viewModels/userWater.viewModel';
var BottleComponent = /** @class */ (function () {
    function BottleComponent(usersService, changeDetectorRef) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this._date = null;
        this.animationPercent = 0;
        this.increase_per_step = 100;
        this.userWater = new UserWaterViewModel();
        this.userWater.water_target = 0;
        this.userWater.min_water_target = 0;
        this.userWater.consumed = 0;
    }
    Object.defineProperty(BottleComponent.prototype, "date", {
        set: function (value) {
            var _this = this;
            this._date = value;
            var percentB = document.getElementById('percentB');
            var waterdrop = document.getElementById('waterdrop');
            var waterdropWhite = document.getElementById('waterdrop-white');
            percentB.style.color = '#00ccff';
            waterdrop.style.display = 'block';
            waterdropWhite.style.display = 'none';
            this.animationPercent = 0;
            this.usersService.getUserWater(this._date).subscribe(function (userWater) {
                _this.userWater = userWater;
                var newPercent = _this.userWater.consumed * 100 / _this.userWater.water_target;
                if (newPercent >= 95) {
                    newPercent = 90;
                }
                _this.changeDetectorRef.detectChanges();
                _this.animateTo(newPercent);
            });
        },
        enumerable: true,
        configurable: true
    });
    BottleComponent.prototype.fixedNumber = function (number) {
        if (number === 0) {
            return 0;
        }
        return (number / 1000).toFixed(1);
    };
    BottleComponent.prototype.increase = function () {
        var ml = this.userWater.consumed + this.increase_per_step;
        var target_ml = this.userWater.water_target;
        var new_percent = ml * 100 / target_ml;
        if (ml > target_ml) {
            return;
        }
        if (new_percent >= 95) {
            new_percent = 90;
        }
        this.updateMl(this.increase_per_step);
        this.userWater.consumed = ml;
        this.changeDetectorRef.detectChanges();
        this.animateTo(new_percent);
    };
    BottleComponent.prototype.animateTo = function (newPercent) {
        var _this = this;
        var percentB = document.getElementById('percentB');
        var water = document.getElementById('water');
        var waterdrop = document.getElementById('waterdrop');
        var waterdropWhite = document.getElementById('waterdrop-white');
        var percent = this.animationPercent;
        var interval;
        interval = setInterval(function () {
            percent += 5;
            // @ts-ignore
            water.style.transform = 'translate(0' + ',' + (100 - percent) + '%)';
            if (percent > 50) {
                percentB.style.color = '#fff';
                waterdrop.style.display = 'none';
                waterdropWhite.style.display = 'block';
            }
            if (percent >= newPercent) {
                _this.animationPercent = newPercent;
                clearInterval(interval);
            }
        }, 120);
    };
    BottleComponent.prototype.updateMl = function (add_ml) {
        this.usersService.addUserWater(this._date, { add_ml: add_ml }).subscribe();
    };
    return BottleComponent;
}());
export { BottleComponent };
